import React from 'react';

const CurrentContext = React.createContext(null);

export default CurrentContext